import Axios from '@/assets/js/AxiosPlugin'

// 消费记录
export const searchSpendList = params => { return Axios.post('/api/Admin/Record/searchSpendList', params) }

// 消费备注
export const setSpendRemark = params => { return Axios.post('/api/Admin/Record/setSpendRemark', params) }

// 消费统计
export const spendStatistics = params => { return Axios.post('/api/Admin/Statistics/spend', params) }

// 退款/补扣
export const modifySpend = params => { return Axios.post('/api/Admin/Record/modifySpend', params) }

// 转移
export const changeSpendShop = params => { return Axios.post('/api/Admin/Record/changeSpendShop', params) }



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/CashRecordApp/apis/index.js